import { Option } from '../../../../shared/options/domain/option';
import { CriteriaKey } from '../criteria';

export const batchOption: Option<CriteriaKey> = {
  name: 'AWS Batch',
  description:
    'A managed batch compute service that makes it easy to run batch jobs on AWS.',
  tags: ['Containers', 'Batch computing'],
  pros: ['Scalable', 'Cost-effective', 'Secure'],
  cons: ['Cost-optimization', 'Management overhead'],
  documentationLink: 'https://aws.amazon.com/batch/',
  criteriaScores: {
    asyncExecution: { score: { value: 7 } },
    scalability: { score: { value: 10 } },
    unlimitedExecutionTimeout: { score: { value: 10 } },
    storagePersistance: { score: { value: 1 } },
    vendorLockIn: { score: { value: 1 } },
    containerizationLimitations: { score: { value: 10 } },
    operationalManagement: { score: { value: 8 } },
    etlOriented: { score: { value: 3 } },
    batchingProcessing: { score: { value: 10 } },
  },
};
